import React from 'react'
import { withTranslation } from 'react-i18next';

function LoginRequiredOverlay(props) {
    const { t } = props

  return (
    <section class="overlay">
        <div class="overlay-window-container">
            <div class="overlay-window">
                <div class="overlay-content padding-0">
                    <div class="overlay-header">
                        <div class="overlay-header-title">
                            <h2 style={{color: "#000 !important"}}>Attention</h2>
                            <p>{props.overlayMessage ? props.overlayMessage : localStorage.getItem("roomID") ? t(`profile.after_registration_not_CI`) : t(`profile.before_registration_not_CI`)}</p>
                        </div>
                        <div class="overlay-header-icon">
                            <i class="fas fa-lock"></i>
                        </div>
                    </div>
                </div>
                <div class="overlay-controls">
                    <button class="button w-100" onClick={props.goBack}>Ok</button>
                </div>
            </div>
        </div>
    </section>
  )
}

export default (withTranslation('translations')(LoginRequiredOverlay));